import React, {useState} from 'react'
import {useHistory} from 'react-router-dom'
import styled from 'styled-components'
import Button from 'lib/ui/Button'
import {categoryRoute} from 'organization/Obie/ObieRoutes'
import NameCompletionDialog from 'organization/Obie/Blocks/ProcessForm/NameCompletionDialog'
import TypeWriter from 'organization/Obie/Blocks/ProcessForm/TypeWriter'
import {Completion} from 'organization/Obie/ObieServiceProvider'
import {useOrganization} from 'organization/OrganizationProvider'
import ChatIcon from 'organization/Obie/Blocks/ProcessForm/ChatIcon'

export default function Complete(props: {
  category_id: string
  completion?: Completion
  dependencies?: string
}) {
  const {category_id, completion} = props
  const {routes} = useOrganization()
  const history = useHistory()

  const [allTyped, setAllTyped] = useState(false)
  const [nameDialogOpen, setNameDialogOpen] = useState<boolean>(false)

  const toggleNameCompletionDialog = () =>
    setNameDialogOpen((current) => !current)

  const viewCompletions = () => {
    const cRoute = categoryRoute(routes, category_id)
    history.push(cRoute.root)
  }

  if (!completion) {
    return <ChatIcon />
  }

  return (
    <Container>
      <NameCompletionDialog
        completion={completion}
        onClose={toggleNameCompletionDialog}
        viewCompletions={viewCompletions}
        open={nameDialogOpen}
      />

      <TypeWriter
        text={completion.completion}
        onFinish={() => setAllTyped(true)}
      />

      <ButtonBox>
        <SaveCompletionButton
          type="button"
          variant="contained"
          color="primary"
          showing={allTyped}
          onClick={toggleNameCompletionDialog}
        >
          Name this Completion
        </SaveCompletionButton>
        <ViewCompletionsButton
          type="button"
          variant="contained"
          color="primary"
          showing={allTyped}
          onClick={viewCompletions}
        >
          View all Completions
        </ViewCompletionsButton>
      </ButtonBox>
    </Container>
  )
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

const ButtonBox = styled.div`
  display: flex;
  margin: ${(props) => props.theme.spacing[8]} 0;
  padding-bottom: ${(props) => props.theme.spacing[8]};
`

const SaveCompletionButton = styled(Button)<{showing?: boolean}>`
  display: ${(props) => (props.showing ? 'block' : 'none')};
  margin-right: ${(props) => props.theme.spacing[4]};
`

const ViewCompletionsButton = styled(Button)<{showing?: boolean}>`
  display: ${(props) => (props.showing ? 'block' : 'none')};
  margin-left: ${(props) => props.theme.spacing[4]};
`
